module.exports = __webpack_public_path__ + "static/img/eicad_function01.db92a2bc.png";